export const fetchCareersQuery = `
query CourseTrail ($workspaceId: Int,){
  CourseTrail{
    all(workspaceId: $workspaceId, perPage: 1000, onlyWithCourses: false){
        totalCount
      items{
      
        dateCreated
        name
        id
        
        courses(published: ALL_COURSES) {
          totalCount
          items {
            id
            postId
            post{
              title
            }
          }
        }

        relatedMedia {
          content
          mediaitemid
        }
      }
    }
  }
}
`;
